import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule  } from '@angular/common';
import { singleOrderDetails, } from '../Shared/interfaces/singleOrderDetail.interface';
import { QRCodeModule } from 'angularx-qrcode';
import { ApiResponce } from '../Shared/interfaces/apiResponce.interface';
import { SharedService } from '../Shared/services/shared.service';
import { RestaurantUser } from '../Shared/interfaces/loginUserRes.interface';

@Component({
  selector: 'app-invoices',
  standalone: true,
  imports: [CommonModule, QRCodeModule],
  templateUrl: './invoices.component.html',
  styleUrl: './invoices.component.scss',
})
export class InvoicesComponent implements OnInit {
  @Input() show: boolean = false;
  @Input() placeOrderObjDetail!: singleOrderDetails;
  @Input() updateInvoiceType: { id: number; name: string }[] = [];
  @Input() isOrderEdit:boolean = false;
  @Output() updateModal = new EventEmitter<boolean>();
  @Output() responseForKichen = new EventEmitter<{
    loader?: boolean;
    Order_id?: number 
    detail_Ids?: number[];
  }>();
  @ViewChild('invoiceCont', { static: false }) invoiceCont!: ElementRef;

  invoiceDialog: { show: boolean; type: string } = { show: false, type: '' };
  placeOrderObj!: singleOrderDetails;
  userData!: RestaurantUser;
  isOnGoing:boolean = false;
  
  static_logo_url: string = 'https://admin.cherryberryrms.com/public/Temp/1313/images/1701441676TBC.PNG';
  branch_logo: string = '';
  branch_name: string = '';
  currancy:string ='';
  constructor(private sharedS: SharedService) {}

  ngOnInit(): void {
    this.currancy = this.sharedS.currancySign;
    this.getLocalStorageData();
    this.invoiceDialog = {
      show: this.show,
      type: '',
    };
    let kitchenInvoiceTrue = this.updateInvoiceType.find((val: any) => val.id === 1) ? true : false;

    if (kitchenInvoiceTrue) {
      let IdsOfPrintInvoice: number[] = [];
      this.areForOngoingOrder(this.placeOrderObjDetail.order_details)
      if (this.placeOrderObjDetail.order_details) {
        this.placeOrderObjDetail.order_details.filter((item: any) => {
          if(item.is_printed_in_kitchen === null || item.is_printed_in_kitchen === 0) {
            IdsOfPrintInvoice.push(item.id);
          }
        });
      } else {
        this.placeOrderObj = this.placeOrderObjDetail;
        setTimeout(() => {
          this.printFunct();
        }, 0);
      }
      if (IdsOfPrintInvoice.length > 0) {
        this.markAsKitchenPrint(this.placeOrderObjDetail, IdsOfPrintInvoice);
      } else {
        this.placeOrderObj = this.placeOrderObjDetail;
        setTimeout(() => {
          this.printFunct();
        }, 0);
      }
    } else {
      this.placeOrderObj = this.placeOrderObjDetail;
      setTimeout(() => {
        this.printFunct();
      }, 0);
    }

    console.log(this.placeOrderObj,'----user data')
  }

  // ngAfterViewInit(): void {
  //   console.log(this.branch_logo);
  // }

  getLocalStorageData() {
    this.sharedS.getData().subscribe((val: any) => {
      this.userData = val.user;
      this.branch_logo = val.user.restaurant_branch_logo_url;
    });
  }

  markAsKitchenPrint(KitchenOrderObj: any, IdAry: any) {
    let payload = {
      order_detail_ids: IdAry,
    };
    this.sharedS
      .sendPostRequest('mark_order_detail_as_kitchen_printed', payload)
      .subscribe({
        next: (res: ApiResponce) => {
          if (res.Success) {
            this.placeOrderObj = KitchenOrderObj;
            setTimeout(() => {
              this.printFunct();
            }, 0);
            this.responseForKichen.emit({
              Order_id: KitchenOrderObj.dailyorder_id,
              detail_Ids: IdAry,
            });
          }
        },
        error: (err: any) => {},
      });
  }

  getDiscountPerc(value1: any, value2: any): string {
    const x = (value1 / value2) * 100;
    return `Discount(${x.toFixed(2)}%)`;
  }

  getPrice(a: any, b: any) {
    return `${this.currancy}.${a * b}`;
  }

  printFunct() {
    if (this.updateInvoiceType.length < 1) {
      this.hideInvoiceDialog(false);
      return;
    }

    if (!this.invoiceCont) {
      console.error('Invoice content is not available');
      return;
    }

    const printContents = this.invoiceCont.nativeElement.innerHTML;

    if (!printContents) {
      console.error('No invoice content to print');
      return;
    }

    // Create a new window for printing
    const popupWindow = window.open('', '_blank', '');

    // Write the content to the new window and add print styles
    if (popupWindow) {
      this.hideInvoiceDialog(false);
      popupWindow.document.open();

      // Copy styles from the document
      const styles = Array.from(document.styleSheets)
        .map((styleSheet) => {
          try {
            return Array.from(styleSheet.cssRules)
              .map((rule) => rule.cssText)
              .join('');
          } catch (e) {
            return '';
          }
        })
        .join('');

      // Write all collected invoice content to the window with page breaks
      popupWindow.document.write(`
        <html>
          <head>
            <title>Print Invoices</title>
            <style>
              ${styles}
            </style>
          </head>
          <body class="printStyling" onload="window.print();window.close()">
          <div class="invoice">
            ${printContents}
          </div>
          
          </body>
        </html>
      `);
      popupWindow.document.close();
    }
  }

  getAddress(address: any) {
    // const splitAddress = address;
    // const start = splitAddress.indexOf('Address:') + 8;
    // const end = splitAddress.indexOf(', Location:');
    // const result = splitAddress.substring(start, end).trim();
    return address;
  }

  hideInvoiceDialog(val: boolean) {
    this.invoiceDialog.show = val;
    this.updateModal.emit(val);
  }

  checkPaidStatus() {
    if (parseInt(this.placeOrderObj.amount_paid) >= parseInt(this.placeOrderObj.total) ){
      return 'PAID';
    } else {
      return 'UNPAID';
    }
  }
 
  parseFloatPrice(value: string) {
   return parseFloat(value);
  }

  areForOngoingOrder(orderDetails: any[]) {
    let checkalltrue =  orderDetails.every(item => item.is_printed_in_kitchen === 1);
    let checkallnull =  orderDetails.every(item => item.is_printed_in_kitchen === null);
    if(checkallnull == true || checkalltrue == true){
      this.isOnGoing = false;
    }else{
      this.isOnGoing = true;
    }
  }

  onImageError() {
    this.branch_logo = this.static_logo_url;
  } 
}